window.addEventListener('load', function () {
    const mainHeader = document.querySelector('.main-header')
    var headerHeight = mainHeader.clientHeight
    
    // Fixed header functionality
    window.onscroll = function(e) {
        if(!mainHeader.classList.contains('main-header--multiple')){
            if (this.oldScroll < this.scrollY) {
                // Downscroll code
                if (window.scrollY > headerHeight){
                    // Fix the header
                    mainHeader.classList.add('main-header--fixed')
                    mainHeader.style.top = `-${headerHeight}px`
                    document.body.style.paddingTop = `${headerHeight}px`
                }
            } else {
                // Upscroll code
                if(mainHeader.classList.contains('main-header--fixed') && window.scrollY > headerHeight){
                    mainHeader.style.top = `0px`
                }
                if(mainHeader.classList.contains('main-header--fixed') && window.scrollY <= headerHeight){
                    // Make header relative again
                    mainHeader.classList.remove('main-header--fixed')
                    mainHeader.style.top = ``
                    document.body.style.paddingTop = ``
                }
            }
            this.oldScroll = this.scrollY;
        }
    }

    // Header Search
    // The search drawer do not use Bootstrap functions to open, because its auto-focus functionality conflicts with an iOS setting

    // Show header search drawer on click
    const headerSearchButtons = document.querySelectorAll(`[aria-controls="searchDrawer"]`)
    headerSearchButtons.forEach(btn => {
        btn.onclick = () => {
            showSearchDrawer()
        }
    })

    // Close search drawer by clicking the close button or backdrop
    const closeearchDrawerBtn = document.querySelectorAll(`.close-search-drawer`)
    closeearchDrawerBtn.forEach(btn => {
        btn.onclick = () => {
            closeSearchDrawer()
        }
    })

    // Close search drawer by pressing esc
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            //if esc key was not pressed in combination with ctrl or alt or shift
            const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
            if (isNotCombinedKey) {
                closeSearchDrawer()
            }
        }
    })

    // Function to show the search drawer
    function showSearchDrawer() {
        // hide menu
        const menu = document.getElementById('mobileMenu')
        if (menu.classList.contains('show')) {
            menu.classList.remove('show')
            menu.nextSibling.remove()
        }

        // show search drawer
        const searchDrawer = document.getElementById('searchDrawer')
        searchDrawer.classList.add('show')

        // Focus on input
        const searchDrawerInput = document.querySelector('#searchDrawerInput')
        searchDrawerInput.focus()
    }

    // Function do close the search drawer
    function closeSearchDrawer() {
        // Close menu
        var menuOffCanvas = new bootstrap.Offcanvas('#mobileMenu')
        menuOffCanvas.hide()

        // Close search drawer
        const searchDrawer = document.getElementById('searchDrawer')
        searchDrawer.classList.remove('show')

        // Remove body inline styles
        document.body.style.overflow = ''
        document.body.style.paddingRight = ''
    }
})
